// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/file/file.v2.proto (package no.jotta.openapi.file.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { AllocateRequest, AllocateResponse, CopyRequest, CopyResponse, CreateFolderRequest, CreateFolderResponse, DeletePermanentlyRequest, DeletePermanentlyResponse, DeleteRequest, DeleteResponse, DownloadZipRequest, DownloadZipResponse, GetPathRequest, GetPathResponse, ListFolderRequest, ListFolderResponse, ListRevisionsRequest, ListRevisionsResponse, MoveRequest, MoveResponse, RecentFilesRequest, RecentFilesResponse, RestoreRequest, RestoreResponse } from "./file.v2_pb.js";
import { PingRequest, PingResponse } from "../ping_pb.js";
/**
 * This is the first step of a 2-part file upload process:
 * 1. Allocate the file upload to a specific path with an AllocateRequest.
 * 2. Upload the file content by sending a HTTP POST to the `upload_url` you received in the AllocateResponse.
 *
 *
 * #### File Upload
 *
 * Upload request must be done with method `POST` and headers
 *
 * - `Content-Type: application/octet-stream`
 * - `Authorization: Bearer`
 *
 * to the `upload_url` given in the AllocateResponse.
 *
 * Resume of uploads is supported using the Range header:
 * `Range: bytes={resume_position}-`
 *
 * Make sure that your Range header matches the `resume_position` from the AllocateResponse or the file will become corrupt.
 * Also keep in mind that the requested byte range in the Range header is zero-indexed.
 *
 * For example: `Range: bytes=0-49` will give you the first 50 bytes of a file with total file size.
 *
 * Upload endpoint return two different 20x responses according to outcome of the upload:
 *
 * - `200 OK`:
 *    Upload completed and file is stored.
 *
 * - `202 Accepted`:
 *    Upload was interrupted or similarly did not finish. The file upload needs to be resumed.
 *
 * - `204 No Content`:
 *    Upload completed, but the uploaded file is deleted or no longer the current revision of the file.
 *    To avoid upload loops where several agents are uploading the same file over and over again it's advised
 *    to not retry upload on 204 responses. Note that for 204 response there is no response body as the uploaded file is no longer current.
 *
 * - `206 Partial Content`:
 *    A resumed upload has been completed and file is stored.
 *
 * #### Error response codes
 *
 * - `400 Bad Request`:
 *   The request is malformed or the `upload_id` in the url is invalid. Client must re-allocate.
 *
 * - `409 Conflict`:
 *   A upload to this object is already in progress, or have not completed yet. Try again at a later time.
 *
 * - `420 Incomplete upload`:
 *    Upload was interrupted or similar leaving the file incomplete.
 *    File upload needs to be resumed - allocate again to find the exact resume position.
 *    Note that you might get a new _upload_url_ from allocate.
 *
 * - `421 Corrupt upload`:
 *    File was completely uploaded, but corrupt.
 *    File must be re-uploaded by doing a new allocation and upload to the new `upload_url`.
 *    The most common cause of this error is that either the allocated checksum is incorrect, or the user have done changes to the file while it was being uploaded,
 *    resulting in a different checksum.
 *
 * - `460 Insufficient Storage`:
 *   This file upload will exceed the users quota and is hence not allowed. The user doesn't have enough space left on his/her own account and need to either delete something or upgrade.
 *
 * - `480 Write Lock`:
 *   Account is locked for writing, meaning the user will not be able to upload anything or perform any operations that causes more usage, such as copy. Available values for _cause_ in the error response:
 *     - "PAYMENT_LOCK": Account is locked due to lack of payment. Will be unlocked if user renews or places a new order or updates credit card information.
 *     - "EXPIRE_LOCK": Account is locked because the subscription is expired. Will be unlocked if user places a new order or add credit card to continue subscription.
 *     - "BUSINESS_LOCK": Account is locked because the business subscription quota is full. User should contact business admin.
 *     - "BREACH_LOCK": Account is locked due to breach of terms and conditions and any other suspicious activity. User must contact support.
 *
 * - `481 Read Lock`:
 *   Account is locked for both writing and reading, meaning the user won't really be able to do anything operations against Jottacloud. Available values for _cause_ in the error response:
 *     - "PAYMENT_LOCK": Account is locked due to lack of payment. Will be unlocked if user renews or places a new order or updates credit card information..
 *     - "EXPIRE_LOCK": Account is locked because the subscription is expired. Will be unlocked if user places a new order or add credit card to continue subscription.
 *
 * - `491 Rejected, do not retry`:
 *    File upload was rejected and the retries will not work either.
 *    The file checksum did not pass the legal check.
 *
 * - `500 Server Error`:
 *    On any unexpected server error. Please try allocating again and contact support referring to the request's `x-id` header if the problem persists.
 *
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.Allocate
 */
export const allocate = {
    localName: "allocate",
    name: "Allocate",
    kind: MethodKind.Unary,
    I: AllocateRequest,
    O: AllocateResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Create a new folder, including any missing parent-folders, on the given path.
 * If a folder already exists at the given path, the request is a noop.
 * If a file exists at the given path, the request fails with a `CONFLICT` error
 *
 * Note: It is not necessary to make a CreateFolderRequest before an AllocateRequest,
 * since the AllocateRequest also creates any missing folders on the file path.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.CreateFolder
 */
export const createFolder = {
    localName: "createFolder",
    name: "CreateFolder",
    kind: MethodKind.Unary,
    I: CreateFolderRequest,
    O: CreateFolderResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Get the item residing on the given path. The item can be a folder or a file.
 *
 * Issuing a GetPath with path `/` is a good starting point to discover your file tree.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.GetPath
 */
export const getPath = {
    localName: "getPath",
    name: "GetPath",
    kind: MethodKind.Unary,
    I: GetPathRequest,
    O: GetPathResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Copy a file or folder to a different path.
 *
 * You can only copy paths where source and destination has effectively the same owner.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.Copy
 */
export const copy = {
    localName: "copy",
    name: "Copy",
    kind: MethodKind.Unary,
    I: CopyRequest,
    O: CopyResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Move a file or folder to a different path.
 *
 * You can only move paths where source and destination has same owner.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.Move
 */
export const move = {
    localName: "move",
    name: "Move",
    kind: MethodKind.Unary,
    I: MoveRequest,
    O: MoveResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Delete a given file or folder. The item(s) are marked as deleted and will appear in the trash.
 * The deleted items are purged after 30 days and removed permanently.
 * Items can be restored anytime within these 30 days.
 *
 * Folders are always deleted recursively, which means all sub-folders and files inside the deleted folder are also deleted.
 * Note that deleting folders that contain many subitems (e.g. tens of thousands) may take a long time.
 *
 * The delete operation has no effect if the item was already deleted.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.Delete
 */
export const delete$ = {
    localName: "delete",
    name: "Delete",
    kind: MethodKind.Unary,
    I: DeleteRequest,
    O: DeleteResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Restore a deleted file or folder marked for deletion (trash).
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.Restore
 */
export const restore = {
    localName: "restore",
    name: "Restore",
    kind: MethodKind.Unary,
    I: RestoreRequest,
    O: RestoreResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Permanently delete a file or folders marked for deletion (trash).
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.DeletePermanently
 */
export const deletePermanently = {
    localName: "deletePermanently",
    name: "DeletePermanently",
    kind: MethodKind.Unary,
    I: DeletePermanentlyRequest,
    O: DeletePermanentlyResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * List all revisions stored for the given path. Only available for files.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.ListRevisions
 */
export const listRevisions = {
    localName: "listRevisions",
    name: "ListRevisions",
    kind: MethodKind.Unary,
    I: ListRevisionsRequest,
    O: ListRevisionsResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.file.v2.FileService.RecentFiles
 */
export const recentFiles = {
    localName: "recentFiles",
    name: "RecentFiles",
    kind: MethodKind.Unary,
    I: RecentFilesRequest,
    O: RecentFilesResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * DownloadZip returns a url and parameters that can be used to download the requested paths as a Zip Archive.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.DownloadZip
 */
export const downloadZip = {
    localName: "downloadZip",
    name: "DownloadZip",
    kind: MethodKind.Unary,
    I: DownloadZipRequest,
    O: DownloadZipResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * ListFolder provides a reduced API for listing all children of a path.
 * ListFolder operations are only supported for `/Sync` (the root) and subfolders of `/Sync`, `/Backup` and `/Archive`.
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.ListFolder
 */
export const listFolder = {
    localName: "listFolder",
    name: "ListFolder",
    kind: MethodKind.Unary,
    I: ListFolderRequest,
    O: ListFolderResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.file.v2.FileService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.file.v2.FileService"
    }
};
